import React, { Component } from "react";

import { Link } from "react-router-dom";

class NotFound extends Component {
    constructor(props: any) {
        super(props);
    }

    render() {
        return (
            <div className="mt20 mb20 tc">
                未找到此页面，<Link to="/">点击回到首页</Link>
            </div>
        );
    }
}

export default NotFound;
